// extracted by css-extract-rspack-plugin
export default {"cls1":"PackPreviewRows-cls1_sY3","cls2":"PackPreviewRows-cls2_LXn PackPreviewRows-cls1_sY3"};